import React, { createContext, useContext, useEffect, useState } from 'react';
import { adminAuth } from '../api';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('bt_admin_token'));
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    adminAuth.me()
      .then((res) => setAdmin(res.data.admin))
      .catch(() => {
        localStorage.removeItem('bt_admin_token');
        setToken(null);
        setAdmin(null);
      })
      .finally(() => setLoading(false));
  }, [token]);

  const login = (data) => {
    localStorage.setItem('bt_admin_token', data.token);
    setToken(data.token);
    setAdmin(data.admin);
  };

  const logout = () => {
    localStorage.removeItem('bt_admin_token');
    setToken(null);
    setAdmin(null);
  };

  const value = { token, admin, loading, isAdminAuthenticated: !!token, login, logout };

  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
}

export const useAdminAuth = () => useContext(AdminAuthContext);
